import { render } from "./ShortcutsWidget.vue?vue&type=template&id=d455b106"
import script from "./ShortcutsWidget.vue?vue&type=script&lang=js"
export * from "./ShortcutsWidget.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./LogbooksWidget.yml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Fpeeristics%2Frails-frontend%2Fapp%2Fassets%2Fvue%2Fwidgets%2FShortcutsWidget.vue&lang=yml&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__